export const SET_WEBCASTS_RAW = "SET_WEBCASTS_RAW";
export const TOGGLE_CHAT_SIDEBAR_VISIBILITY = "TOGGLE_CHAT_SIDEBAR_VISIBILITY";
export const SET_CHAT_SIDEBAR_VISIBILITY = "SET_CHAT_SIDEBAR_VISIBILITY";
export const TOGGLE_HASHTAG_SIDEBAR_VISIBILITY =
  "TOGGLE_HASHTAG_SIDEBAR_VISIBILITY";
export const SET_HASHTAG_SIDEBAR_VISIBILITY = "SET_HASHTAG_SIDEBAR_VISIBILITY";
export const TOGGLE_LAYOUT_DRAWER_VISIBILITY =
  "TOGGLE_LAYOUT_DRAWER_VISIBILITY";
export const SET_LAYOUT_DRAWER_VISIBILITY = "SET_LAYOUT_DRAWER_VISIBILITY";
export const ADD_WEBCAST = "ADD_WEBCAST";
export const ADD_WEBCAST_AT_POSITION = "ADD_WEBCAST_AT_POSITION";
export const SWAP_WEBCASTS = "SWAP_WEBCASTS";
export const REMOVE_WEBCAST = "REMOVE_WEBCAST";
export const RESET_WEBCASTS = "RESET_WEBCASTS";
export const SET_LAYOUT = "SET_LAYOUT";
export const SET_TWITCH_CHAT = "SET_TWITCH_CHAT";
export const SET_DEFAULT_TWITCH_CHAT = "SET_DEFAULT_TWITCH_CHAT";
export const WEBCASTS_UPDATED = "WEBCASTS_UPDATED";
export const SET_FAVORITE_TEAMS = "SET_FAVORITE_TEAMS";
export const TOGGLE_POSITION_LIVESCORE = "TOGGLE_POSITION_LIVESCORE";
